import {
	GET_DEDUCTIONPLANS, GET_DEDUCTIONPLANS_SUCCESS, GET_DEDUCTIONPLANS_FAIL,
	GET_DEDUCTIONPLANS_DETAILS, GET_DEDUCTIONPLANS_DETAILS_SUCCESS, GET_DEDUCTIONPLANS_DETAILS_FAIL,
	DEDUCTIONPLAN_CREATE, DEDUCTIONPLAN_CREATE_FAIL, DEDUCTIONPLAN_CREATE_SUCCESS,
	DEDUCTIONPLAN_DELETE, DEDUCTIONPLAN_DELETE_FAIL, DEDUCTIONPLAN_DELETE_SUCCESS,
	DEDUCTIONPLAN_UPDATE, DEDUCTIONPLAN_UPDATE_FAIL, DEDUCTIONPLAN_UPDATE_SUCCESS, RESET, GET_DEDUCTION_PLANS_MASTER, GET_DEDUCTION_PLANS_MASTER_SUCCESS, GET_DEDUCTION_PLANS_MASTER_FAIL, GET_CURRENT_PAY_PERIOD, GET_CURRENT_PAY_PERIOD_SUCCESS, GET_CURRENT_PAY_PERIOD_FAIL, GET_FUTURE_PAY_PERIODS, GET_FUTURE_PAY_PERIODS_SUCCESS, GET_FUTURE_PAY_PERIODS_FAIL, GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC, GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_SUCCESS, GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_FAIL, DEDUCTION_PLAN_CREATE_EMPLOYEE, DEDUCTION_PLAN_CREATE_EMPLOYEE_SUCCESS, DEDUCTION_PLAN_CREATE_EMPLOYEE_FAIL, RESET_VALIDATION, RESET_CREATE_RESULT_DEDUCTION
} from "./actionTypes";

const initialState = {
	deductionplanList: [],
	deductionplan: {},
	postingResult: {},
	loading: false,
	loadingDeductionplanDetails: false,
	deductionplanSetting: {},
	loadingdeductionplanSetting: false,
	// loading: false,
	error: {
		message: "",
	},
	isDeductionPlansFetching: false,
	deductionPlans: [],
	errorDeductionPlans: {},
	currentPayPeriod: {},
	isPayPeriodLoading: false,
	futurePayPeriodList: [],
	isFuturePayPeriodLoading: false,
	deductionValidation: {},
	isValidationLoading: false,
	createResult: {},
	createLoading: false,
};

const DeductionplanReducer = (state = initialState, action) => {
	if (!action)
		return state;
	switch (action.type) {
		case GET_DEDUCTIONPLANS:
			state = { ...state, loading: false };
			break;
		case GET_DEDUCTIONPLANS_SUCCESS:
			state = { ...state, deductionplanList: action.payload, loading: false };
			break;
		case GET_DEDUCTIONPLANS_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
		case GET_DEDUCTION_PLANS_MASTER:
			state = { ...state, isDeductionPlansFetching: false };
			break;
		case GET_DEDUCTION_PLANS_MASTER_SUCCESS:
			state = { ...state, deductionPlans: action.payload?.data, isDeductionPlansFetching: false };
			break;
		case GET_DEDUCTION_PLANS_MASTER_FAIL:
			state = {
				...state,
				deductionPlans: [],
				errorDeductionPlans: action.payload?.error,
				isDeductionPlansFetching: false,
			};
			break;
		case GET_DEDUCTIONPLANS_DETAILS:
			state = { ...state, loadingDeductionplanDetails: true };
			break;
		case GET_DEDUCTIONPLANS_DETAILS_SUCCESS:
			state = { ...state, deductionplan: action.payload, loadingDeductionplanDetails: false };
			break;
		case GET_DEDUCTIONPLANS_DETAILS_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loadingDeductionplanDetails: false,
			};
			break;
		case DEDUCTIONPLAN_CREATE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case DEDUCTIONPLAN_CREATE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false };

			break;
		case DEDUCTIONPLAN_CREATE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				postingResult: {},
				loading: false,
			};
			break;
		case DEDUCTIONPLAN_UPDATE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case DEDUCTIONPLAN_UPDATE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false };
			break;
		case DEDUCTIONPLAN_UPDATE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
		case DEDUCTIONPLAN_DELETE:
			state = { ...state, postingResult: {}, loading: true };
			break;
		case DEDUCTIONPLAN_DELETE_SUCCESS:
			state = { ...state, postingResult: action.payload, loading: false };
			break;
		case DEDUCTIONPLAN_DELETE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				loading: false,
			};
			break;
		case GET_CURRENT_PAY_PERIOD:
			state = { ...state, isPayPeriodLoading: false };
			break;
		case GET_CURRENT_PAY_PERIOD_SUCCESS:
			state = { ...state, currentPayPeriod: action.payload?.data, isPayPeriodLoading: false };
			break;
		case GET_CURRENT_PAY_PERIOD_FAIL:
			state = {
				...state,
				error: action.payload?.error,
				isPayPeriodLoading: false,
			};
			break;
		case GET_FUTURE_PAY_PERIODS:
			state = { ...state, isFuturePayPeriodLoading: false };
			break;
		case GET_FUTURE_PAY_PERIODS_SUCCESS:
			state = { ...state, futurePayPeriodList: action.payload?.data, isFuturePayPeriodLoading: false };
			break;
		case GET_FUTURE_PAY_PERIODS_FAIL:
			state = {
				...state,
				error: action.payload?.error,
				isFuturePayPeriodLoading: false,
			};
			break;
		case GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC:
			state = { ...state, isValidationLoading: false };
			break;
		case GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_SUCCESS:
			state = { ...state, deductionValidation: action.payload?.data, isValidationLoading: false };
			break;
		case GET_VALIDATION_FOR_PAY_PERIOD_NET_MISC_FAIL:
			state = {
				...state,
				error: action.payload?.error,
				isValidationLoading: false,
			};
			break;
		case DEDUCTION_PLAN_CREATE_EMPLOYEE:
			state = { ...state, createResult: {}, createLoading: true };
			break;
		case DEDUCTION_PLAN_CREATE_EMPLOYEE_SUCCESS:
			state = { ...state, createResult: action.payload, createLoading: false };

			break;
		case DEDUCTION_PLAN_CREATE_EMPLOYEE_FAIL:
			state = {
				...state,
				error: {
					message: "Error",
				},
				createResult: {},
				createLoading: false,
			};
			break;

		case RESET_VALIDATION:
			state = { ...state, deductionValidation: {}, isValidationLoading: false };
			break;

		case RESET_CREATE_RESULT_DEDUCTION:
			state = { ...state, createResult: {}, createLoading: false };
			break;

		case RESET:
			state = { ...state, deductionplan: {} };
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default DeductionplanReducer;